import { KeyValueModel } from "model/api";

export const ModNF: KeyValueModel[] = [
    new KeyValueModel(1, "Modelo 01"),
    new KeyValueModel(2, "Modelo 02"),
];
